import { Archive} from '@phosphor-icons/react';

export default Archive;